import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import CreateMarketingActivityFilter from '../../filters/CreateMarketingActivityFilterNew';
import {
  LocationFilterInitialState,
  LoggedUserType,
  MapOptionType,
  SelectOptionType,
  SetMarketActivityFilterType,
  UserType,
} from '../../utils/Types';
import {
  API_STATUS,
  CLICK_ACTIONS,
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  DEFAULT_PAGE_SIZE,
  REVIEW_MARKET_ACTIVITY_FILTER_INIT,
} from '../../utils/Constant';
import {
  MARKETING_STATUSES,
  ViewActivitiesColumnsHeaders,
  changePrimaryEmp,
  getActivityDetails,
  getDistrictsWithNoVillages,
  handleAction,
  listTypes,
  marketingActivityListRequest,
  removeEmployee,
  saveComment,
  updateMarketingActivity,
} from './activityHelper';
import KTable from '../../components/KTable';
import KPagination from '../../components/KPagination';
import ViewMarketingActivityModal from '../modals/ViewMarketingActivityModal';

import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  getMarketingActivityList,
  marketingActivitySelector,
} from '../../features/marketingActivitySlice';
import MarketingActivitySucessModal from '../modals/MarketingActivitySuccessModal';
import CenterSpinner from '../../components/CenterSpinner';
import {
  fetchVillagesOfDistricts,
  locationFilterSelector,
} from '../../features/locationFilterSlice';
import ToggleSwitch from '../../components/ToggleSwitch';
import classNames from 'classnames';
import UpdateMarketingActivityPage from './UpdateMarketingActivityPage';
import { loginSelector } from '../../features/loginSlice';
import { useLoader } from '../../loader/LoaderProvider';

const ViewMarketingActivityPage: React.FunctionComponent = () => {
  const [stateOption, setStateOption] = useState<SelectOptionType[]>([
    DEFAULT_OPTION_LOCATION_SET_TARGET,
  ]);
  const [filterValues, setFilterValues] = useState<SetMarketActivityFilterType>(
    REVIEW_MARKET_ACTIVITY_FILTER_INIT
  );
  const [selectedValues, setSelectedValues] =
    useState<SetMarketActivityFilterType>(REVIEW_MARKET_ACTIVITY_FILTER_INIT);
  const pagination = useAppSelector(marketingActivitySelector)
    .marketingActivityList.pagination;
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [openViewModal, setOpenViewModal] = useState<boolean>(false);
  const [selectedActivity, setSelectedActivity] = useState<any>();
  const { showLoader, setShowLoader } = useLoader();
  const [showApproveSuccess, setShowApproveSuccess] = useState<boolean>(false);
  const [activityDetails, setActivityDetails] = useState<any>();
  const [comment, setComment] = useState<string>('');
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const [updateActivity, setUpdateActivity] = useState<boolean>(false);
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;
  const user: LoggedUserType = useAppSelector(loginSelector).user;

  const dispatch = useAppDispatch();

  const activityData = useAppSelector(marketingActivitySelector)
    .marketingActivityList.result;
  const apiStatus = useAppSelector(marketingActivitySelector)
    .marketingActivityList.status;
  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;

  const zoneOption =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...zoneOptionRaw]
      : zoneOptionRaw;

  const onTableAction = (data: any, tableHeader: any) => {
    if (tableHeader.action === CLICK_ACTIONS.UPDATE_MARKETING_ACTIVITY) {
      setSelectedActivity(data?.activityUniqueId);
      setUpdateActivity(true);
    } else if (
      tableHeader.action === CLICK_ACTIONS.REVIEW_MARKETING_ACTIVITY &&
      (data.activityStatusId === MARKETING_STATUSES.REVIEW_PENDING ||
        data.activityStatusId === MARKETING_STATUSES.COMPLETED)
    ) {
      setSelectedActivity(data?.activityUniqueId);
      setOpenViewModal(true);
    }
  };

  const locationData: LocationFilterInitialState = useAppSelector(
    locationFilterSelector
  );

  const getMarketingActivities = () => {
    dispatch(
      getMarketingActivityList(
        marketingActivityListRequest(
          currentPage,
          pageSize,
          filterValues,
          userDetails,
          user
        )
      )
    );
  };
  useEffect(() => {
    if (zoneOption && zoneOption.length === 1) {
      const stateArray = allStates[zoneOption[0].value];
      setStateOption(stateArray);
      setFilterValues({
        ...filterValues,
        zone: zoneOption[0].value,
        state:
          stateArray.length === 1
            ? stateArray[0].value
            : DEFAULT_OPTION_LOCATION_SET_TARGET.value,
      });
    }
  }, [zoneOption]);

  useEffect(() => {
    if (user?.roleId && userDetails?.reportingZones) getMarketingActivities();
  }, [pageSize, currentPage, selectedValues, user, userDetails]);

  useEffect(() => {
    const districtsWithNoVillages = getDistrictsWithNoVillages(
      activityData,
      locationData
    );
    if (districtsWithNoVillages.length) {
      dispatch(
        fetchVillagesOfDistricts({
          districtId: districtsWithNoVillages,
        })
      );
    }
  }, [activityData]);
  const requestActivityDetails = () => {
    getActivityDetails(
      dispatch,
      selectedActivity,
      setShowLoader,
      setActivityDetails
    );
  };
  useEffect(() => {
    if (selectedActivity) {
      setShowLoader(true);
      requestActivityDetails();
    }
  }, [selectedActivity]);

  useEffect(() => {
    if (!updateActivity) {
      setSelectedActivity(null);
    }
  }, [updateActivity]);

  const onSubmitFilter = () => {
    setSelectedValues((prev: any) => ({
      ...prev,
      ...filterValues,
    }));
    setCurrentPage(1);
  };
  const handleReset = () => {
    const newFilter = { ...REVIEW_MARKET_ACTIVITY_FILTER_INIT };
    if (stateOption && stateOption.length === 1) {
      newFilter.state = stateOption[0].value;
    }
    if (zoneOption && zoneOption.length === 1) {
      newFilter.zone = zoneOption[0].value;
    }
    setFilterValues(newFilter);
    setSelectedValues(newFilter);
  };

  const handleToggleSwitch = () => {
    setShowFilter((prev) => !prev);
  };

  useEffect(() => {
    if (apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [apiStatus]);

  return (
    <>
      {!updateActivity ? (
        <div className="ml-4">
          <Label className="text-heading">View Sales Activity</Label>
          <ToggleSwitch isOpen={showFilter} onClick={handleToggleSwitch} />
          <div className="task-item-parent-view">
            {showFilter && (
              <CreateMarketingActivityFilter
                filterValues={filterValues}
                onReset={handleReset}
                setFilterValues={setFilterValues}
                listType={listTypes.review}
                onSubmitFilter={onSubmitFilter}
              />
            )}
            <KTable
              data={activityData}
              columnHeader={ViewActivitiesColumnsHeaders}
              onAction={onTableAction}
              isLoading={false}
              tableParentClass={classNames('mt-3 table-parent-view-marketing', {
                hideFilters: !showFilter,
              })}
              locationData={locationData}
            />

            {activityData && activityData.length > 0 && (
              <KPagination
                totalPages={pagination?.totalPages}
                currentPage={pagination?.currentPage}
                pageSize={pagination?.pageSize}
                onPageChange={setCurrentPage}
                onSizeChange={setPageSize}
                fromItem={pagination?.fromItem}
                toItem={pagination?.toItem}
                totalItems={pagination?.totalItems}
              />
            )}

            <ViewMarketingActivityModal
              isOpen={openViewModal}
              toggleModal={(action: any) => {
                if (action === CLICK_ACTIONS.NO_ACTION) {
                  setOpenViewModal((prevState) => !prevState);
                  setSelectedActivity(undefined);
                } else {
                  handleAction(
                    { action, activityDetails, comment, setShowLoader },
                    dispatch,
                    setShowApproveSuccess,
                    requestActivityDetails,
                    getMarketingActivities,
                    setOpenViewModal,
                    setSelectedActivity
                  );
                }
              }}
              activityDetails={activityDetails}
              comment={comment}
              setComment={setComment}
              setActivityDetails={setActivityDetails}
            />
            <MarketingActivitySucessModal
              isOpen={showApproveSuccess}
              toggleSuccessModal={() => setShowApproveSuccess((prev) => !prev)}
              type={'create'}
              activityDetails={activityDetails}
            />
          </div>
        </div>
      ) : (
        <UpdateMarketingActivityPage
          activityDetails={activityDetails}
          setUpdateActivity={setUpdateActivity}
          comment={comment}
          showLoader={showLoader}
          setComment={setComment}
          onSaveComment={() => {
            saveComment(
              comment,
              activityDetails,
              setShowLoader,
              setComment,
              setActivityDetails,
              dispatch
            );
          }}
          onRemoveEmployee={(employeeId) => {
            removeEmployee(
              activityDetails,
              employeeId,
              setShowLoader,
              setActivityDetails,
              dispatch
            );
          }}
          onUpdate={(
            selectedEmployees: any,
            assignedEmployeeIds: (number | string)[]
          ) => {
            updateMarketingActivity(
              activityDetails.marketingActivityId,
              selectedEmployees,
              assignedEmployeeIds,
              setShowLoader,
              setUpdateActivity,
              dispatch
            );
          }}
          onPrimaryChange={(empId: number | string) => {
            changePrimaryEmp(
              empId,
              activityDetails.activityUniqueId,
              activityDetails.marketingActivityId,
              setShowLoader,
              setActivityDetails,
              dispatch
            );
          }}
        />
      )}
      <CenterSpinner showLoader={showLoader} />
    </>
  );
};

export default ViewMarketingActivityPage;
